import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item12/subitm1.jpg";
import img2 from "../assets/images/item12/subitm2.jpg";
import img3 from "../assets/images/item12/subitm3.jpg";
import img4 from "../assets/images/item12/subitm4.jpg";
import img5 from "../assets/images/item12/subitm5.jpg";

const rowsData = [
  {
    id: 1,
    title: "PLC",
    text: "Reliable PLCs for automated control of industrial processes.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `PLCs automate machinery and production processes efficiently. Offer precise control over operations and reduce manual intervention.Durable and designed for continuous industrial use.
`
  },
  {
    id: 2,
    title: "Touch Panel",
    text: "User-friendly touch panels for intuitive industrial machine control.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Touch panels allow operators to monitor and control machinery easily. Offer interactive displays with customizable interfaces. Durable and designed for industrial environments.
`
  },
  {
    id: 3,
    title: "Printed Circuit Board",
    text: "High-quality printed circuit boards for reliable electronic performance.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `PCBs connect electronic components and ensure smooth signal transmission. Made from durable materials for long-lasting performance. Available in single-layer, multi-layer, and customized designs.
`
  },
  {
    id: 4,
    title: "Machine Computer",
    text: "Industrial machine computers for seamless operation and monitoring.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `Machine computers control and monitor industrial equipment effectively. Provide high-speed processing for automation and production systems. Built to withstand harsh industrial environments.
`
  },
  {
    id: 5,
    title: "Drives",
    text: "Efficient drives for controlling motors and industrial machinery.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `Drives regulate motor speed, torque, and direction in machinery. Ensure energy-efficient operation and precise control. Durable construction for heavy-duty industrial use.`
  }
];

function Z12() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z12;